import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

import locale_en from './en.json'
import locale_zh from './zh.json'

const messages = {
  en: locale_en,
  zh: locale_zh,
}
// Create VueI18n instance with options
let language = 'zh'

const me = window.localStorage.getItem('me')
if (me) {
  // fix: sso login user= {token: "xxx"}
  if (JSON.parse(me).language) {
    language = JSON.parse(me).language.toLowerCase().slice(0, 2)
  }
}
if (!language) language = window.navigator.language.toLowerCase().slice(0, 2) || 'en'

export default new VueI18n({
  locale: language, // set locale
  fallbackLocale: 'en',
  messages, // set locale messages
})
